module.exports = __webpack_public_path__ + "static/media/delete.c9263fb0.svg";